import React from 'react';
import { cn } from '../cn.js';

/**
 * Design-system tabs.
 * items: string[] | { id, label }[]
 */
const Tabs = ({
    items = [],
    activeIndex = 0,
    activeId,
    size = 'medium',
    onChange,
    className = '',
}) => {
    const normalized = items.map((item, index) => (
        typeof item === 'string'
            ? { id: String(index), label: item }
            : item
    ));

    const isActive = (item, index) => (
        activeId != null ? item.id === activeId : index === activeIndex
    );

    return (
        <ul
            className={cn(
                'tabs__list mt-32 flex w-full flex-nowrap items-center justify-start overflow-x-auto border-b border-solid border-light-grey py-10',
                className,
            )}
        >
            {normalized.map((item, index) => (
                <li
                    key={item.id}
                    className={cn(
                        'main__subtitle tabs__list-item mx-10 mb-[-1px] shrink-0 cursor-pointer whitespace-nowrap border-b-2 border-solid border-transparent px-[2vw] py-10 text-light-grey',
                        size && `tabs__list-item_${size}`,
                        size === 'large' && 'min-w-[160px] text-center',
                        size === 'medium' && 'text-center',
                        isActive(item, index) && 'tabs__list-item_active border-pink-accent text-dark-green',
                    )}
                    onClick={() => onChange?.(index, item)}
                    role="tab"
                    aria-selected={isActive(item, index)}
                >
                    {item.label}
                </li>
            ))}
        </ul>
    );
};

export default Tabs;
